<template>
    <div>
        <app-layout>
	        <template v-slot:header>
		        <Header :title="$t('payment_types')"
		                :isNewButton="checkPermission('paymenttype_store')"
		                @new-button-click="add"
		                @filter-div-status="datatable.filterStatus = $event">
		        </Header>
	        </template>
	        <template v-slot:header-mobile>
		        <HeaderMobile :title="$t('payment_types')"
		                      :isNewButton="checkPermission('paymenttype_store')"
		                      @new-button-click="add"
		                      @filter-div-status="datatable.filterStatus = $event">
		        </HeaderMobile>
	        </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
                <b-row>
                    <b-col sm="6" md="4" lg="3" xs="12">
                        <b-form-group :label="$t('payment_type')">
                            <payment-type-type-selectbox v-model="datatable.queryParams.filter.type">
                            </payment-type-type-selectbox>
                        </b-form-group>
                    </b-col>

                    <b-col sm="6" md="4" lg="3" xs="12">
                        <b-form-group :label="$t('bank')">
                            <bank-selectbox v-model="datatable.queryParams.filter.bank_id">
                            </bank-selectbox>
                        </b-form-group>
                    </b-col>
                </b-row>


            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                :total="datatable.total" :queryParams="datatable.queryParams" :lineNumbers="false"
                @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable">
            </datatable>
            <CommonModal ref="modal" size="xl">
                <template v-slot:CommonModalTitle>
                    <div>{{ $t(id == 0 ? "add" : "edit") }}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div class="row mb-5 align-items-center">
                        <div class="col-12">
                            <ValidationObserver ref="storeForm">
                                <div class="row">
                                    <div class="col-4">
                                        <ValidationProvider name="code" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('code')">
                                                <b-form-input :validate-error="errors[0]" v-model="form.code">
                                                </b-form-input>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-4">
                                        <ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('name')">
                                                <b-form-input :validate-error="errors[0]" v-model="form.name">
                                                </b-form-input>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-4">
                                        <ValidationProvider name="type" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('pay_type')">
                                                <payment-type-type-selectbox :validate-error="errors[0]" v-model="form.type">
                                                </payment-type-type-selectbox>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-4">
                                        <ValidationProvider name="bank_id" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('bank_id')">
                                                <bank-selectbox :validate-error="errors[0]" v-model="form.bank_id">
                                                </bank-selectbox>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-4">
                                        <ValidationProvider name="branch_name" rules="required"
                                            v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('branch_name')">
                                                <b-form-input :validate-error="errors[0]" v-model="form.branch_name">
                                                </b-form-input>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>
                                    <div class="col-6">
                                        <ValidationProvider name="account_number" rules="required"
                                            v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('account_number')">
                                                <b-form-input :validate-error="errors[0]" v-model="form.account_number">
                                                </b-form-input>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                    <div class="col-6">
                                        <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                                            <b-form-group :label="$t('status')">
                                                <status-selectbox :validate-error="errors[0]" v-model="form.status">
                                                </status-selectbox>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </div>

                                </div>
                            </ValidationObserver>
                        </div>
                        <div class="col-12 mt-3 d-flex">
                            <b-button @click="store" type="button" variant="primary" class="btn-lg mr-2">
                                {{ $t("save").toUpper() }}
                            </b-button>
                        </div>
                    </div>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import qs from "qs";
import PaymentTypeService from "@/services/PaymentTypeService";
import CommonModal from "@/components/elements/CommonModal";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import PaymentTypeTypeSelectbox from '../../../components/interactive-fields/PaymentTypeTypeSelectbox.vue';
import StatusSelectbox from '../../../components/interactive-fields/StatusSelectbox.vue';
import BankSelectbox from '../../../components/interactive-fields/BankSelectbox.vue';


export default {
    components: {
        AppLayout,
        Header,
	    HeaderMobile,

        DatatableFilter,
        Datatable,
        CommonModal,
        ValidationProvider,
        ValidationObserver,
        PaymentTypeTypeSelectbox,
        StatusSelectbox,
        BankSelectbox,
    },
    metaInfo() {
        return {
            title: this.$t("payment_types"),
        };
    },
    data() {
        return {
            id: 0,
            form: {},
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: "",
                        field: "buttons",
                        html: true,
                        sortable: false,
                        tdClass: "p-0 text-center w-40 align-middle",
                        buttons: [
                            {
                                text: this.$t("edit"),
                                class: "ri-edit-box-line",
                                permission: "paymenttype_update",
                                callback: (row) => {
                                    this.id = row.id;
                                    this.loadData();
                                },
                            },
                            {
                                text: this.$t("delete"),
                                class: "ri-delete-bin-2-line",
                                permission: "paymenttype_delete",
                                callback: (row) => {
                                    this.delete(row.id);
                                },
                            },
                        ],
                    },
                    {
                        label: this.$t("id"),
                        field: "id",
                        sortable: true,
                    },
                    {
                        label: this.$t("code"),
                        field: "code",
                        sortable: true,
                    },

                    {
                        label: this.$t("name"),
                        field: ("name"),
                        sortable: true,
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: "id",
                    page: 1,
                    limit: 20,
                },
            },
        };
    },
    methods: {
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : "";
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams,
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false }),
            };

            return PaymentTypeService.getAll(config)
                .then((response) => {
                    this.datatable.rows = response.data.data;
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        loadData() {
            if (this.id > 0) {
                PaymentTypeService.get(this.id)
                    .then((response) => {
                        this.$refs.storeForm.reset();
                        this.form = response.data.data;
                        this.$refs.modal.$refs.commonModal.show();
                    })
                    .catch((error) => {
                        if (error.data.message) {
                            this.$toast.error(this.$t("api." + error.data.message));
                        }
                    });
            }
        },
        async store() {
            const isValid = await this.$refs.storeForm.validate();
            if (isValid) {
                if (this.id == 0) {
                    PaymentTypeService.store(this.form, this.value)
                        .then((response) => {
                            this.$toast.success(this.$t("api." + response.data.message));
                        })
                        .catch((error) => {
                            this.showErrors(error)
                        })
                } else {
                    PaymentTypeService.update(this.id, this.form)
                        .then((response) => {
                            this.$toast.success(this.$t("api." + response.data.message));
                        })
                        .catch((error) => {
                            this.showErrors(error)
                        })
                }
            }
        },
        showErrors(error) {
            if (error.status == 422) {

                if (error.data.errors.name) {
                    this.$refs.storeForm.errors.name.push(error.data.errors.name[0]);
                }

                if (error.data.errors.code) {
                    this.$refs.storeForm.errors.code.push(error.data.errors.code[0]);
                }
                if (error.data.errors.type) {
                    this.$refs.storeForm.errors.type.push(error.data.errors.type[0]);
                }
                if (error.data.errors.bank_id) {
                    this.$refs.storeForm.errors.bank_id.push(error.data.errors.bank_id[0]);
                }
                if (error.data.errors.account_number) {
                    this.$refs.storeForm.errors.account_number.push(error.data.errors.account_number[0]);
                }
                if (error.data.errors.branch_number) {
                    this.$refs.storeForm.errors.branch_number.push(error.data.errors.branch_number[0]);
                }
                if (error.data.errors.status) {
                    this.$refs.storeForm.errors.status.push(error.data.errors.status[0]); p
                }
            }
            else if (error.status == 406) {
                this.$toast.error(this.$t('api.' + error.data.message));
            }
        },
        delete(id) {
            this.deleteModal(() => {
                PaymentTypeService.deletePeriod(id)
                    .then((response) => {
                        this.filter();
                        this.$toast.success(this.$t("api." + response.data.message));
                    })
                    .catch((error) => {
                        this.$toast.error(this.$t("api." + error.data.message));
                    });
            });
        },
        add() {
            this.id = 0;
            this.$refs.storeForm.reset();
            this.form = {};
            this.$refs.modal.$refs.commonModal.show();
        },
    },
};
</script>

